import React from "react";
import Navbar from "../components/site/Navbar";
import Footer from "../components/site/Footer";
import FinalCTA from "../components/site/FinalCTA";
import FaqAccordion from "../components/site/FaqAccordion";
import { PageHead } from "../components/site/Section";
import { FAQ_GROUPS } from "../data/content";

export default function Faq() {
  return (
    <div className="App" data-testid="faq-page">
      <Navbar />
      <main>
        <PageHead kicker="Bar stock control questions" title="Questions bar owners ask us"
          lede="Straight answers about stocktakes, ordering, GP, plans and your data. Can't find yours? Email hello@barloapp.co.uk." />
        <section style={{ paddingTop: 0 }}>
          <div className="wrap faq-page">
            {FAQ_GROUPS.map((g, gi) => (
              <div className="faq-group" key={g.title}>
                <h2>{g.title}</h2>
                <FaqAccordion items={g.items} testidPrefix={`faq-${gi}`} openFirst={false} />
              </div>
            ))}
          </div>
        </section>
        <FinalCTA testidTrial="faq-cta-trial" />
      </main>
      <Footer />
    </div>
  );
}
